import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './excel-file.reducer';
import { IExcelFile } from 'app/shared/model/excel-file.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IExcelFileDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const ExcelFileDetail = (props: IExcelFileDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { excelFileEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          <Translate contentKey="examsysApp.excelFile.detail.title">ExcelFile</Translate> [<b>{excelFileEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="file">
              <Translate contentKey="examsysApp.excelFile.file">File</Translate>
            </span>
          </dt>
          <dd>
            {excelFileEntity.file ? (
              <div>
                {excelFileEntity.fileContentType ? (
                  <a onClick={openFile(excelFileEntity.fileContentType, excelFileEntity.file)}>
                    <Translate contentKey="entity.action.open">Open</Translate>&nbsp;
                  </a>
                ) : null}
                <span>
                  {excelFileEntity.fileContentType}, {byteSize(excelFileEntity.file)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="tableName">
              <Translate contentKey="examsysApp.excelFile.tableName">Table Name</Translate>
            </span>
          </dt>
          <dd>{excelFileEntity.tableName}</dd>
        </dl>
        <Button tag={Link} to="/excel-file" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/excel-file/${excelFileEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ excelFile }: IRootState) => ({
  excelFileEntity: excelFile.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(ExcelFileDetail);
